import React from "react";
import { connect } from "react-redux";
import {Button, Callout} from "@blueprintjs/core";
import { loggedInUserGuid } from "../../store/iam/selectors";
import { resendActivationEmail, fetchUser } from "../../store/users/operations";
import { getUserWithId, isUpdatingUser, isActivatedUser} from "../../store/users/selectors";
import { Translate, I18n } from "react-redux-i18n";
import LoadingIndicator from "../../components/LoadingIndicator";

class ActivateAccountBanner extends React.Component {

    componentDidMount(){
        this.props.fetchUser(this.props.myGuid);
    }

    sendActivationEmail=()=>{
        this.props.resendActivationEmail(this.props.myGuid);
    }  

    render() {
        return (
            <>  
                {this.props.my_profile && !this.props.isActivated &&
                    <section className="gray-bg activation-wrapper">
                        <div className="main-container">
                            <div className="content-wrapper">
                                <Callout
                                    icon="info-sign"
                                    intent="primary"
                                    className="dismissable-note"
                                    title={I18n.t("user_activation_banner.heading")}
                                >
                                    <p>
                                        <Translate value="user_activation_banner.paragraph1" />
                                        {this.props.my_profile.email}
                                        <Translate value="user_activation_banner.paragraph2" />
                                    </p>
                                    {this.props.loading && <LoadingIndicator />}
                                    {!this.props.loading &&
                                        <Button intent="primary" className="small" onClick={this.sendActivationEmail}>
                                            <Translate value="user_activation_banner.resend_activation_email" />
                                        </Button>
                                    }
                                </Callout>
                            </div>
                        </div>
                    </section>
                }
            </>
        );
    }
}

const mapStateToProps = state => ({
    locale: state.i18n.locale,
    myGuid: loggedInUserGuid(state),
    my_profile: getUserWithId(state, loggedInUserGuid(state)),
    loading: isUpdatingUser(state),
    isActivated: isActivatedUser(state, loggedInUserGuid(state))
});
const mapDispatchToProps = dispatch => ({
    resendActivationEmail: email=>dispatch(resendActivationEmail(email)),
    fetchUser: id=>dispatch(fetchUser(id))
});
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ActivateAccountBanner);
